import { create } from 'zustand';
import { roomBody } from '../state/roomBody';

// ── WHERE THE PLAYER IS, AS OPPOSED TO WHERE THE CAMERA IS ───────────────────
//
// In first person they are the same point, and most of the world has always
// read `camera.position` as "the player". In third person the camera stands a
// couple of metres behind the body, so the few things that must know where the
// BODY is — door triggers, getting into a car, the body itself — read this
// instead, through playerPos(). WalkControls writes it every frame.
export const player = {
  x: 0, y: 0, z: 0,  // y = the FEET (0 on the street; a room's floor in third person)
  vx: 0, vz: 0,
  jump: 0,
  height: 0.85,      // the body's height (PlayerBody), for framing it
  third: false,      // true while the camera is behind the body
  // A way to face while standing still (world yaw, 0 = +z), set by whatever is
  // directing you (the Hype-U elevator turns you to its doors); null = your own.
  faceYaw: null,
};

/** The player's ground position: the body in third person, else the camera.
    In a third-person room it is the body's eye point (state/roomBody). */
export function playerPos(camera) {
  if (roomBody.on) return roomBody.v;
  return player.third ? player : camera.position;
}

// The point-of-view choice the player makes (V). Remembered across visits.
const KEY = 'world:pov3';
const readPref = () => { try { return localStorage.getItem(KEY) !== '0'; } catch { return true; } };
export const usePovStore = create((set) => ({
  wantThird: readPref(),
  toggle: () => set((s) => {
    const wantThird = !s.wantThird;
    try { localStorage.setItem(KEY, wantThird ? '1' : '0'); } catch { /* private mode */ }
    return { wantThird };
  }),
}));

// ?tpbody=<avatarId> — dev/test: borrow a roster body for third person when you
// have none of your own (a guest in a headless test). Never affects others.
export const TP_TEST_BODY = (() => {
  try { const v = new URLSearchParams(window.location.search).get('tpbody'); return v ? Number(v) || v : null; } catch { return null; }
})();
